import useMobile from 'src/hooks/useMobile'
import DualLangHeader from '../components/DualLangHeader'
import RedButton from '../components/RedButton'
import { GeneralHeaderText, siteScreenshotCollage, siteScreenshotCollageMobile, chibiMari } from '../styles'
import { InteractiveSectionWrapper, Wave, DualLangEnglish, CollageContainer, Collage, Mari } from '../styles/InteractiveSection.styles'

const InteractiveSection = ({ scrollToPlanSelect }) => {
  const isMobile = useMobile()
  const hideMari = useMobile(971)
  const imgSrc = isMobile ? siteScreenshotCollageMobile : siteScreenshotCollage

  return (
    <InteractiveSectionWrapper>
      <Wave />
      <DualLangHeader otherLang='インタラクティブな学習!' style={{ justifySelf: 'center' }}>
        <DualLangEnglish isMobile={isMobile}>
          <GeneralHeaderText>An Interactive</GeneralHeaderText>
          <GeneralHeaderText style={{ justifySelf: 'center', lineHeight: isMobile ? 0.75 : '' }}>Experience!</GeneralHeaderText>
        </DualLangEnglish>
      </DualLangHeader>
      <CollageContainer>
        <Collage src={imgSrc} alt='interactive website activities' />
        {!hideMari && <Mari src={chibiMari} alt='Mari' />}
      </CollageContainer>
      <RedButton onClick={scrollToPlanSelect} style={{ justifySelf: 'center' }}>Start Your First Lesson</RedButton>
      <Wave bottom />
    </InteractiveSectionWrapper>
  )
}

export default InteractiveSection
